/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticationResponseDTO
 */
export interface AuthenticationResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponseDTO
     */
    jwt?: string;
}

export function AuthenticationResponseDTOFromJSON(json: any): AuthenticationResponseDTO {
    return AuthenticationResponseDTOFromJSONTyped(json, false);
}

export function AuthenticationResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationResponseDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jwt': !exists(json, 'jwt') ? undefined : json['jwt'],
    };
}

export function AuthenticationResponseDTOToJSON(value?: AuthenticationResponseDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jwt': value.jwt,
    };
}

